<template>
  <div class="tab-content_description tab-description">
    <div class="tab-description__container page-container">
      <div class="tab-description__row">
        <div class="tab-description__half-wrapper tab-description__half-wrapper--gallery">
          <photo-gallery></photo-gallery>
          <div v-if="isDesktop" class="under-gallery-desktop">
            <product-badge-description></product-badge-description>
            <with-title
              v-if="Object.keys(shortCharacteristics).length"
              :title="$t('product-description__general-characteristics')"
              :with-container="false"
              class="product-short-characteristics"
            >
              <div class="product-description__product-name" v-if="characteristicsName">
                {{ characteristicsName }}
              </div>
              <product-card-characteristics
                class="product__short-characteristics"
                size="medium"
                :values="shortCharacteristics"
                product-page
              ></product-card-characteristics>
            </with-title>
            <div class="all-characteristics" v-if="isCharactiristicsShow" @click="openCharacteristicsTab">{{ $t('product-description__all-characteristics') }} →</div>
          </div>
        </div>
        <div class="tab-description__half-wrapper">
          <ProductHead />
          <rendered-blocks
            uid="countdown_product"
            :product-id="productId"
            :product-sku="baseProductCode"
            without-top-margin
            without-container
          ></rendered-blocks>
          <div v-if="isPreorder && !isArchive" class="preorder-green-info">
            <div class="preorder-green-info__title">{{ $t('product-page__preorder-green-info__title') }}</div>
            <div class="preorder-green-info__text">{{ $t('product-page__preorder-green-info__text') }}</div>
            <div class="preorder-green-info__bottom-title">{{ $t('product-page__preorder-green-info__bottom-title') }}</div>
          </div>
          <product-in-stock></product-in-stock>
          <product-options v-if="options.length" :options="options"></product-options>
          <div v-if="isDesktop" class="product__actions product-actions" :data-productKey="code">
            <div v-if="price" class="product-actions__price-wrap">
              <product-price
                :old-price="oldPrice"
                :price="price"
                vertical
                size="medium"
              ></product-price>
            <!--              <bonus-info v-if="!config.happy_hours && isAwardedBonuses" class="product__actions__bonus-info"></bonus-info>-->
            </div>
            <div ref="btnBuy" class="product-actions__btns-wrap">
              <div class="product-actions__buy-wrap">
                <buy-btn
                  v-if="isPreorder && !isArchive"
                  pre-order-btn
                  size="medium"
                  :title-ru="titleRu"
                  :product-id="productId"
                  :code="code"
                  product-page
                  :price="price"
                  class="product-actions__btn product-actions__btn--pre-order"
                ></buy-btn>
                <buy-btn
                  v-else-if="price && (inStock || availableInStore)"
                  size="medium"
                  :price="price"
                  :code="code"
                  :title-ru="titleRu"
                  :product-id="productId"
                  :store-id="availableInStore ? availableInStore.store_id : ''"
                  product-page
                  class="product-actions__btn product-actions__btn--buy"
                ></buy-btn>
                <wait-list-btn
                  v-else
                  :in-wait-list-status="isInWaitList"
                  :product-id="productId"
                  product-page
                  class="product-actions__btn product-actions__btn--wait-list"
                ></wait-list-btn>
                <pay-part-btn v-if="price && (inStock || availableInStore) && !isPreorder" :is-desktop="isDesktop"></pay-part-btn>
                <!--                <buy-btn-->
                <!--                  v-if="inStock && !isManager && config.isEnabledOneClickAndCallback"-->
                <!--                  type="invert"-->
                <!--                  size="medium"-->
                <!--                  :title-ru="titleRu"-->
                <!--                  :product-id="productId"-->
                <!--                  :code="code"-->
                <!--                  :price="price"-->
                <!--                  one-click-btn-->
                <!--                  product-page-->
                <!--                  class="product-actions__btn product-actions__btn&#45;&#45;one-click"-->
                <!--                ></buy-btn>-->
              </div>
              <div class="product-actions__service-wrap">
                <add-to-comparison-btn
                  class="product-actions__btn product-actions__btn--comparison"
                  product-page
                  :title-ru="titleRu"
                  :product-id="productId"
                ></add-to-comparison-btn>
                <wish-list-btn
                  class="product-actions__btn product-actions__btn--wish-list"
                  product-page
                  :id="productId"
                  :price="price"
                  :analytics-data="analyticsData"
                  :code="code"
                  :is-in-stock="inStock || Object.keys(availableInStore).length > 0"
                  :in-wish-list-status="inWishListStatus"
                ></wish-list-btn>
              </div>
            </div>
          </div>
          <template v-if="!isDesktop">
            <with-title
              :title="$t('product-description__general-characteristics')"
              :with-container="false"
              v-if="Object.keys(shortCharacteristics).length"
            >
              <div class="product-description__product-name" v-if="characteristicsName">
                {{ characteristicsName }}
              </div>
              <product-card-characteristics
                class="product__short-characteristics"
                size="medium"
                :values="shortCharacteristics"
                product-page
              ></product-card-characteristics>
            </with-title>
            <product-badge-description></product-badge-description>
            <div class="all-characteristics" v-if="isCharactiristicsShow" @click="openCharacteristicsTab">{{ $t('product-description__all-characteristics') }} →</div>
          </template>
          <sets-with-product-new
            v-if="setsWithProduct.length"
            :product-id="productId"
            :sets-with-product="setsWithProduct"
          ></sets-with-product-new>
          <description-wrapper
            v-if="!isDesktop"
            :descriptions="descriptions"
            :is-desktop="isDesktop"
          ></description-wrapper>
          <product-details class="product__details"></product-details>
          <pay-part-btn v-if="!isDesktop && price && (inStock || availableInStore)" :is-desktop="isDesktop"></pay-part-btn>
        </div>
      </div>
      <rendered-blocks
        uid="product_page_description"
        :product-id="productId"
        :product-sku="baseProductCode"
        without-container
      ></rendered-blocks>
      <rendered-blocks
        uid="product_page_above_characteristics"
        :product-id="productId"
        :product-sku="code"
        without-container
      ></rendered-blocks>
      <description-wrapper
        v-if="isDesktop"
        :descriptions="descriptions"
        :is-desktop="isDesktop"
      ></description-wrapper>
      <product-reviews-slider :open-tab="openReviewsTab" :is-desktop="isDesktop"></product-reviews-slider>
    </div>
  </div>
</template>

<script>
import DescriptionWrapper from '@/components/product/DescriptionWrapper.vue'
import { mapGetters, mapState, mapActions } from 'vuex'
import WithTitle from '../layouts/WithTitle'
import PhotoGallery from '../../../components/product/product-page/photo-gallery/PhotoGallery'
import ProductInStock from '../../../components/product/ProductInStock'
import AddToComparisonBtn from '../../../components/product/product-comparison/AddToComparisonBtn'
import WishListBtn from '../../../components/product/WishListBtn'
import BuyBtn from '../../../components/cart/BuyBtn'
import WaitListBtn from '../../../components/product/product-page/WaitListBtn'
import ProductCardCharacteristics from '../../../components/product/ProductCardCharacteristics'
import ProductDetails from '../../../components/product/product-page/ProductDetails'
// import ProductFullCharacteristics from '../../../components/product/product-page/ProductFullCharacteristics'
// import ProductInstruction from '../../../components/product/product-page/ProductInstruction'
// import ProductDescriptions from '../../../components/product/product-page/ProductDescriptions'
import ProductBadgeDescription from '../../../components/product/product-page/ProductBadgeDescription'
import { debounce, isAdaptiveMode } from '../../../mixins'
import ProductOptions from '../../../components/product/product-options/ProductOptions'
import SetsWithProductNew from '../../../components/product/product-page/SetsWithProductNew'
// import BonusInfo from '../../../components/product/product-page/BonusInfo'
// import PayPartInfo from '../../../components/product/product-page/pay-part/PayPartInfo'
import ProductPrice from '../../../components/product/ProductPrice'
// import ProductsBuyTogether from '../../../components/product/product-block/ProductsBuyTogether'
// import ProductSale from '../../../components/product/product-page/ProductSale'
import checkNodeVisibilityInViewPort from '@/helpers/checkNodeVisibilityInViewport'
// import ProductsSlider from '../../../components/product/product-block/ProductsSlider'
// import ProductCountdown from '@/components/product/product-page/ProductCountdown'
// import ProductStats from '@/components/product/product-page/ProductStats'
// import ProductCounters from '@/components/product/product-page/ProductCounters'
import RenderedBlocks from '@/components/rendered-blocks/RenderedBlocks'
// import ExpertCallback from '@/components/product/expert-callback/ExpertCallback'
import ProductHead from '@/views/product-page/layouts/ProductHead.vue'
import PayPartBtn from '@/components/product/product-page/pay-part/PayPartBtn.vue'
import ProductReviewsSlider from '@/components/product/ProductReviewsSlider.vue'

export default {
  name: 'ProductDescription',
  data () {
    return {
      isBtnInViewport: false,
      timerVisible: true,
      windowWidth: window.innerWidth
    }
  },
  mixins: [debounce, isAdaptiveMode],
  components: {
    PayPartBtn,
    ProductHead,
    RenderedBlocks,
    DescriptionWrapper,
    ProductReviewsSlider,
    ProductBadgeDescription,
    // ProductStats,
    // ProductCounters,
    // ExpertCallback,
    // ProductCountdown,
    // ProductsSlider,
    // ProductSale,
    // ProductsBuyTogether,
    // PayPartInfo,
    // BonusInfo,
    SetsWithProductNew,
    ProductOptions,
    // ProductBadgeDescription,
    WithTitle,
    // ProductDescriptions,
    // ProductInstruction,
    // ProductFullCharacteristics,
    ProductDetails,
    PhotoGallery,
    ProductInStock,
    AddToComparisonBtn,
    WishListBtn,
    ProductCardCharacteristics,
    ProductPrice,
    BuyBtn,
    WaitListBtn
  },
  props: {
    statsCounters: Array,
    analyticsData: {
      type: Array
    }
  },
  computed: {
    // TODO: remove it
    isHalloweenDate () {
      return (new Date().getTime() / 1000) > 1667077200
    },
    ...mapGetters(['isManager', 'urlLanguagePrefix']),
    ...mapState({
      auth: state => state.user.auth,
      title: state => state.productInfo.productInfo.title,
      isAwardedBonuses: state => state.productInfo.productInfo.isAwardedBonuses,
      productId: state => state.productInfo.productInfo.productId,
      titleRu: state => state.productInfo.productInfo.titleRu,
      inStock: state => state.productInfo.productInfo.inStock,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      isInWaitList: state => state.productInfo.productInfo.isInWaitList,
      inWishListStatus: state => state.productInfo.productInfo.inWishListStatus,
      code: state => state.productInfo.productInfo.code,
      baseProductCode: state => state.productInfo.productInfo.esputnikData.productKey,
      shortCharacteristics: state => state.productInfo.productInfo.shortCharacteristics,
      commentsCount: state => state.comments.comments.total_count,
      descriptions: state => state.productInfo.productInfo.descriptions,
      characteristics: state => state.productInfo.productInfo.characteristics,
      options: state => state.productInfo.productInfo.options,
      isSale: state => state.productInfo.productInfo.isSale,
      countdownTill: state => state.productInfo.productInfo.countdownTill,
      countdownEnabled: state => state.productInfo.productInfo.countdownEnabled,
      setsWithProduct: state => state.productInfo.setsWithProduct,
      price: state => state.productInfo.productInfo.price,
      oldPrice: state => state.productInfo.productInfo.oldPrice,
      buyTogether: state => state.products.buyTogether,
      availableInStore: state => state.productInfo.productInfo.availableInStore,
      combinedProducts: state => state.productInfo.productInfo.combinedProducts,
      initialOffset: state => state.productTabs.initialOffset,
      abExpertBlockVisibility: state => state.abTesting.dataFromCookies?.technicalExpertBlockVisibility,
      config: state => state.init.config,
      isArchive: state => state.productInfo.productInfo.isArchive,
      language: state => state.translation?.language,
      productInfo: state => state.productInfo.productInfo
    }),
    characteristicsName () {
      const arr = Object.keys(this.shortCharacteristics)
      if (arr.length && this.productInfo.analyticsData && this.productInfo.analyticsData.length > 1) {
        return arr[0]
      }
      return ''
    },
    isDesktop () {
      return this.windowWidth > 768
    },
    isCharactiristicsShow () {
      return this.characteristics.length > 0 && Object.values(this.characteristics[0])[0].length > 0
    },
    computedCombinedProducts () {
      return this.combinedProducts?.products?.map(item => {
        item.id = +item.id
        item.code = item.code.toString()
        item.title_ru = item.title_anal
        item.image_url = item.photos.image_url
        item.second_image_url = item.photos.image_url_additional
        item.mobile_image_url = item.photos.image_url_small
        item.rating = item.rating ? item.rating : ''
        item.reviews_count = +item.reviews_count
        item.price = { 'price_new': +item.price_new, 'price_old': +item.price_old }
        item.is_available = !!+item.is_available
        item.is_novelty = !!+item.is_novelty
        item.is_in_wait_list = !!+item.is_in_wait_list
        item.is_in_wish_list = !!+item.is_in_wish_list

        return item
      }).slice(0, 15) ?? []
    },
    computedCombinedProductsLink () {
      return location.origin + location.pathname + '?tab=combined=products'
    },
    isExpertBlockVisible () {
      return this.config?.isEnabledTechnicalExpert && this.inStock
    },
    imageCacheKey () {
      return ('?t=' + Math.ceil((+new Date()) / 1000 / 60))
    },
    isTradeIn () {
      const tradeInProducts = [554, 939, 970, 971, 1125, 1126, 1127, 1144, 1145, 1146, 1147, 1148, 1149, 1209, 1340, 1342, 1343, 1344, 1347, 1348, 1349, 1380, 1381, 1382, 1421, 1422, 1423, 1424, 1425, 1426, 1427, 1428, 1429, 1430, 1432, 1433, 1434, 1435, 1495, 1496, 1497, 1519, 1520, 1521, 1522, 1523, 1524, 1525, 1621, 1699, 1751, 1752, 1754, 1755, 1756, 1758, 1760, 1761, 1773, 1774, 1775, 1776, 1778, 1779, 1780, 1781, 1782, 1783, 1784, 1785, 1788, 1789, 1793, 1836, 1837, 1838, 1839, 1840, 1841, 1842, 1843, 1889, 1890, 1945, 1994, 1995, 1996, 1997, 1998, 1999, 2005, 2006, 2008, 2009, 2010, 2012, 2014, 2015, 2020, 2021, 2022, 2023, 2024, 2144, 2151, 2192, 2193, 2194, 2195, 2196, 2236, 2242, 2259, 2260, 2261, 2262, 2263, 2264, 2265, 2266, 2267, 2268, 2269, 2270, 2271, 2272, 2273, 2274, 2275, 2276, 2279, 2298, 2299, 2300, 2301, 2302, 2311, 2321, 2322, 2323, 2327, 2328, 2334, 2335, 2336, 2337, 2338, 2390, 2391, 2392, 2393, 2394, 2395, 2396, 2397, 2399, 2413, 2414, 2421, 2422, 2423, 2424, 2425, 2431, 2432, 2433, 2440, 2445, 2447, 2453, 2454, 2455, 2456, 2457, 2458, 2459, 2460, 2461, 2462, 2463, 2464, 2465, 2466, 2469, 2470, 2475, 2476, 2477, 2517, 2518, 2524, 2525, 2527, 2528, 2529, 2530, 2531, 2532, 2533, 2534, 2535, 2538, 2539, 2540, 2541, 2543, 2549, 2550, 2551, 2559, 2563, 2564, 2565, 2568, 2569, 2570, 2571, 2572, 2573, 2580, 2582, 2583, 2584, 2585, 2586, 2587, 2588, 2589, 2590, 2591, 2592, 2593, 2594, 2595, 2601, 2602, 2603, 2604, 2605, 2608, 2616, 2620, 2641, 2642, 2658, 2659, 2660, 2661, 2662, 2665, 2666, 2667, 2671, 2673, 2674, 2675, 2679, 2681, 2682, 2684, 2685, 2686, 2687, 2688, 2689, 2690, 2694, 2695, 2696, 2697, 2728, 2729, 2730, 2731, 2732, 2762, 2770, 2772, 2775, 2776, 2777, 2778, 2781, 2782, 2784, 2785, 2786, 2788, 2789, 2790, 2791, 2792, 2796, 2797, 2798, 2799, 2800, 2801, 2802, 2803, 2804, 2805, 2806, 2807, 2808, 2809, 2810, 2811, 2824, 2825, 2826, 2827, 2828, 2829, 2830, 2831, 2832, 2833, 2834, 2835, 2836, 2837, 2838, 2839, 2844, 2859, 2881, 2897, 2898, 2899, 2900, 2901, 2902, 2906, 2918, 2919, 2920, 2921, 2922, 2923, 2925, 2926, 2927, 2928, 2929, 2961, 2962, 2963, 2964, 2970, 2972, 2973, 2975, 2981, 2982, 2983, 2984, 2986, 2987, 2988, 2989, 2998, 2999, 3000, 3001, 3002, 3009, 3010, 3011, 3012, 3013, 3014, 3015, 3016, 3017, 3018, 3019, 3020, 3021, 3022, 3037, 3038, 3039, 3045, 3067, 3068, 3069, 3070, 3071, 3072, 3074, 3076, 3077, 3079, 3080, 3082, 3083, 3084, 3086, 3101, 3102, 3103, 3104, 3105, 3108, 3110, 3112, 3113, 3114, 3115, 3116, 3117, 3124, 3125, 3126, 3127, 3128, 3129, 3130, 3131, 3132, 3133, 3134, 3153, 3154, 3157, 3176, 3177, 3218, 3246, 3252, 3253, 3254, 3255, 3257, 3258, 3259, 3260, 3261, 3262, 3279, 3280, 3281, 3282, 3284, 3288, 3294, 3295, 3296, 3297, 3298, 3303, 3308, 3310, 3311, 3312, 3313, 3314, 3321, 3324, 3380, 3381, 3382, 3385, 3444, 3446, 3447, 3448, 3449, 3457, 3458, 3459, 3460, 3461, 3462, 3463, 3464, 3465, 3466, 3468, 3470, 3473, 3474, 3475, 3476, 3477, 3478, 3479, 3494, 3495, 3496, 3497, 3498, 3499, 3500, 3501, 3502, 3503, 3504, 3505, 3506, 3507, 3508, 3509, 3514, 3580, 3583, 3584, 3585, 3586, 3587, 3588, 3589, 3590, 3591, 3592, 3593, 3594, 3595, 3596, 3597, 3598, 3599, 3600, 3601, 3602, 3603, 3604, 3605, 3606, 3607, 3608, 3609, 3610, 3611, 3612, 3613, 3614, 3615, 3616, 3617, 3618, 3619, 3620, 3621, 3622, 3623, 3652, 3653, 3654, 3655, 3656, 3657, 3658, 3659, 3660, 3661, 3662, 3663, 3664, 3665, 3666, 3667, 3668, 3669, 3670, 3671, 3672, 3673, 3674, 3675, 3676, 3677, 3678, 3679, 3680, 3681, 3682, 3683, 3684, 3685, 3686, 3687, 3688, 3689, 3690, 3691, 3692, 3693, 3694, 3695, 3696, 3697, 3698, 3699, 3700, 3701, 3702, 3703, 3704, 3705, 3706, 3707, 3708, 3709, 3710, 3711, 3712, 3713, 3714, 3715, 3716, 3717, 3718, 3719, 3720, 3721, 3722, 3723, 3724, 3725, 3726, 3727, 3733, 3735, 3736, 3737, 3740, 3741, 3744, 3745, 3772, 3773, 3774, 3775, 3776, 3777, 3778, 3793, 3795, 3796, 3821, 3857, 3905, 3906, 3907, 3908, 3909, 3910, 3917, 3918, 3919, 3920, 3921, 3922, 3923, 3924, 3925, 3926, 3927, 3928, 3929, 3930, 3994, 3995, 3996, 3997, 3999, 4009, 4010, 4011, 4012, 4013, 4014, 4016, 4017, 4018, 4019, 4020, 4021, 4022, 4023, 4024, 4025, 4026, 4028, 4029, 4030, 4031, 4033, 4035, 4039, 4040, 4049, 4050, 4051, 4052, 4053, 4054, 4055, 4056, 4059, 4060, 4061, 4062, 4063, 4064, 4065, 4066, 4067, 4068, 4069, 4077, 4078, 4079, 4080, 4081, 4082, 4083, 4084, 4085, 4086, 4087, 4164, 4165, 4166, 4167, 4168, 4169, 4170, 4171, 4172, 4173, 4174, 4175, 4176, 4177, 4178, 4179, 4180, 4181, 4182, 4184, 4185, 4191, 4192, 4193, 4194, 4195, 4196, 4204, 4212, 4214, 4215, 4216, 4217, 4218, 4220, 4223, 4227, 4228, 4229, 4230, 4233, 4245, 4246, 4247, 4248, 4249, 4250, 4252, 4253, 4254, 4255, 4256, 4257, 4258, 4259, 4260, 4261, 4262, 4263, 4264, 4265, 4266, 4267, 4268, 4269, 4270, 4271, 4272, 4273, 4274, 4275, 4276, 4277, 4278, 4279, 4280, 4281, 4284, 4285, 4290, 4295, 4296, 4351, 4352, 4353, 4358, 4359, 4360, 4362, 4364, 4365, 4366, 4367, 4368, 4369, 4370, 4371, 4372, 4373, 4374, 4375, 4385, 4388, 4389, 4390, 4391, 4393, 4394, 4395, 4396, 4400, 4402, 4411, 4412, 4413, 4416, 4417, 4440, 4515, 4529, 4532, 4551, 4552, 4553, 4554, 4557, 4558, 4560, 4566, 4567, 4568, 4569, 4570, 4571, 4572, 4573, 4574, 4575, 4576, 4591, 4592, 4593, 4599, 4600, 4602, 4603, 4604, 4605, 4606, 4607, 4608, 4609, 4610, 4611, 4612, 4614, 4709, 4710, 4711, 4712, 4713, 4718, 4719, 4720, 4721, 4723, 4724, 4725, 4726, 4727, 4728, 4729, 4730, 4731, 4732, 4733, 4734, 4736, 4737, 4738, 4739, 4742, 4743, 4885, 4886, 4926, 4927, 4929, 4930, 4964, 4965, 4966, 4997, 4998, 4999, 5000, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5017, 5019, 5020, 5043, 5044, 5045, 5046, 5047, 5048, 5106, 5109, 5110, 5111, 5112, 5116, 5117, 5118, 5119, 5127, 5129, 5130, 5131, 5132, 5208, 5209, 5210, 5211, 5214, 5223, 5224, 5228, 5229, 5280, 5282, 5283, 5284, 5285, 5286, 5287, 5288, 5292, 5293, 5296, 5297, 5298, 5299, 5300, 5301, 5302, 5303, 5304, 5305, 5306, 5307, 5311, 5312, 5313, 5314, 5315, 5316, 5317, 5318, 5319, 5320, 5321, 5322, 5324, 5378, 5379, 5381, 5382, 5396, 5397, 5398, 5399, 5400, 5401, 5402, 5404, 5405, 5406, 5407, 5409, 5410, 5411, 5412, 5413, 5414, 5415, 5416, 5417, 5418, 5419, 5420, 5421, 5422, 5426, 5427, 5490, 5491, 5492, 5493, 5494, 5495, 5496, 5497, 5498, 5499, 5500, 5501, 5502, 5503, 5504, 5505, 5506, 5507, 5515, 5516, 5518, 5523, 5524, 5525, 5526, 5527, 5529, 5531, 5532, 5534, 5540, 5541, 5542, 5543, 5566, 5631, 5632, 5633, 5640, 5641, 5642, 5643, 5644, 5645, 5647, 5648, 5649, 5650, 5651, 5652, 5653, 5654, 5714, 5715, 5719, 5720, 5721, 5730, 5731, 5732, 5733, 5734, 5735, 5739, 5740, 5741, 5742, 5743, 5786, 5789, 5791, 5792, 5793, 5794, 5795, 5829, 5832, 5833, 5876, 5877, 5880, 5881, 5882, 5883, 5884, 5888, 5889, 5890, 5891, 5892, 5893, 5894, 5895, 5896, 5897, 5898, 5899, 5900, 5914, 5916, 5917, 5957, 5958, 5961, 5962, 5963, 5964, 5965, 5966, 5967, 5968, 5969, 5970, 5971, 5972, 5973, 5974, 5975, 5976, 5977, 5978, 5979, 5980, 5981, 5982, 5984, 5989, 5990, 5991, 6013, 6014, 6015, 6043, 6044, 6045, 6055, 6056, 6057, 6058, 6059, 6060, 6061, 6062, 6063, 6064, 6286, 6290, 6291, 6342, 6343, 6344, 6345, 6346, 6347, 6348, 6372, 6373, 6374, 6379, 6380, 6381, 6382, 6383, 6384, 6385, 6389, 6390, 6391, 6392, 6393, 6394, 6395, 6396, 6397, 6398, 6400, 6401, 6402, 6403, 6406, 6481, 6482, 6488, 6489, 6492, 6493, 6494, 6495, 6498, 6499, 6500, 6501, 6504, 6505, 6574, 6575, 6576, 6577, 6578, 6579, 6582, 6643, 6644, 6645, 6660, 6661, 6729, 6733, 6734, 6742, 6743, 6744, 6745, 6746, 6747, 6748, 6833, 6863, 6864, 6865, 6866, 6867, 6868, 6869, 6870, 6871, 6872, 6873, 6874, 6875, 6876, 6877, 6878, 6879, 6880, 6881, 6882, 6883, 6884, 6885, 6886, 6887, 6888, 6899, 6900, 6901, 6902, 6903, 6904, 6905, 6907, 6908, 6949, 6950, 6951, 6952, 6954, 6955, 7013, 7014, 7041, 7042, 7043, 7044]
      return !tradeInProducts.includes(this.productId)
    },
    parentCategoryCode () {
      if (this.analyticsData.length) {
        const mainProduct = this.analyticsData.find(el => el.is_main_product)
        if (mainProduct) {
          return mainProduct.id
        }
        return this.analyticsData[0].id
      }
      return this.code
    }
  },
  methods: {
    ...mapActions(['SET_BTN_BUY_SHOW', 'SET_ACTIVE_TAB']),
    openReviewsTab () {
      const data = {
        string: 'comments',
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset
      }
      this.SET_ACTIVE_TAB(data)
    },
    openCharacteristicsTab () {
      const data = {
        string: 'characteristics',
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset
      }
      this.SET_ACTIVE_TAB(data)
    },
    showOrHideBtnBuy () {
      this.debounce(() => {
        this.isBtnInViewport = checkNodeVisibilityInViewPort(this.$refs.btnBuy, false)
        this.SET_BTN_BUY_SHOW(this.isBtnInViewport)
      }, 15)
    },
    handleResize () {
      this.windowWidth = window.innerWidth
    },
    goToCombinedProductsTab () {
      const data = {
        string: 'combined-products',
        top: this.isAdaptiveMode ? this.initialOffset - 40 : this.initialOffset - 50
      }

      this.SET_ACTIVE_TAB(data)
    }
  },
  async mounted () {
    // смотрим если ли во вьюпорте кнопка купить
    this.showOrHideBtnBuy()

    // вешаем листенер для отслеживания если ли во вьюпорте кнопка купить
    window.addEventListener('scroll', this.showOrHideBtnBuy)
    window.addEventListener('resize', this.handleResize)
    await this.$nextTick()
    // Генерируем ивент что описание отрендерено
    window.dispatchEvent(new CustomEvent('productDescriptionReady'))
  },
  beforeDestroy () {
    // удаляем листенер для отслеживания если ли во вьюпорте кнопка купить
    window.removeEventListener('scroll', this.showOrHideBtnBuy)
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="sass">
.product-actions
  .bonus-info__text
    font-size: 16px
</style>
<style scoped lang="sass">

.tab-description__container,
.tab-description__row
  display: flex
  align-items: flex-start
  justify-content: space-between
  position: relative
  flex-flow: column
  width: 100%
  +mmin($tablet)
    flex-flow: row wrap
  &--mt
    margin-top: 30px
    +mmin($tablet)
      margin-top: 80px

.tab-description__half-wrapper
  width: 100%
  position: relative
  margin-bottom: 30px
  display: flex
  flex-direction: column

  +mmin($tablet)
    width: calc(50% - 24px)

  &--gallery
    margin-bottom: 20px
    +mmin($tablet)
      position: sticky
      top: 110px
      margin-bottom: 10px
    +mmin($tablet--hor)
      top: 80px

.tab-description__wrapper
  width: 100%
  position: relative

  &--single
    margin: 0 auto
    max-width: 860px

  &--full
    max-width: 100%
    padding: 0

.product__btns-wrap
  display: flex
  margin-bottom: 30px

  +mmin($tablet)
    margin-bottom: 40px

  &:nth-child(2)
    justify-content: space-between

.add-comment-btn
  position: absolute
  top: 7px
  right: 0

.tab-description__link
  margin-top: 50px

.product__details
  margin-top: 10px

  +mmin($tablet)
    margin-top: 0

.product-actions
  display: flex
  align-items: flex-start
  flex-direction: column
  margin-bottom: 25px

.product-actions__buy-wrap
  display: flex
  align-items: center
  flex-wrap: wrap
  padding-right: 5px
  +mmax(1300)
    padding-right: 0
    margin-bottom: 15px
    justify-content: flex-start
    flex-direction: column
    align-items: flex-start
.product-actions__service-wrap
  display: flex
  align-items: center
  flex-wrap: wrap
  padding-left: 5px
  +mmax(1300)
    padding-left: 0
    width: 100%
.product-actions__btns-wrap
  align-items: center
  justify-content: space-between
  width: 100%
  order: 2
  display: flex
  +mmax(1300)
    flex-direction: column
    align-items: flex-start

.product-actions__btn
  width: 100%
  justify-content: center
  font-size: 16px
  +mmax($tablet)
    margin-top: 30px
    font-size: 16px
  +mmin($tablet)
    width: auto

  &--buy
    margin-right: 10px

  &--pre-order,
  &--wait-list
    width: 100%

.product-actions__btn:not(.product-actions__btn--wish-list)
  &:nth-child(2)
    margin-left: auto

.product-actions__pay-part-info
  width: 100%
  min-width: 300px
  margin-top: 40px
  order: 3

  +mmin($tablet--hor)
    width: 372px
    order: initial
    margin-top: 0
    margin-left: auto

  +mbetween($tablet--hor, $large)
    width: 326px

.product-actions__price-wrap
  width: 100%
  display: flex
  justify-content: space-between
  align-items: center
  order: 1
  margin-bottom: 20px

  +mmin($tablet--hor)
    width: auto
    flex-direction: column
    justify-content: flex-start
    align-items: flex-start
    order: initial

.product__actions__bonus-info
  +mmin($tablet--hor)
    margin-top: 10px

.product__sale
  margin-bottom: 40px

.product__sale-banner-wrap
  display: block
  width: 100%
  border-radius: 7px
  overflow: hidden

  img
    display: block
    width: 100%

.tab-description__half-wrapper--gallery .expert-callback
  max-width: 640px

::v-deep .product__rendered-block
  .product-slider__title
    font-size: 16px

    +mmin($tablet)
      font-size: 18px
.under-gallery-desktop
  padding-left: 80px
.all-characteristics
  cursor: pointer
  display: inline-block
  color: #3E77AA
  font-size: 16px
  font-weight: 400
  margin-top: 10px
  &:hover
    text-decoration: underline
.product-short-characteristics
  margin-top: 25px
.review-wrapper
  display: flex
  align-items: flex-start
  justify-content: space-between
  width: 100%
  .column
    &:first-child
      width: calc(100% - 700px)
      flex-grow: 0
      flex-shrink: 0
    &:last-child
      width: 600px
      flex-shrink: 0
      flex-grow: 0
      padding: 25px
      background-color: #F8F8F8
      border-radius: 3px
.product-description__product-name
  display: inline-block
  padding: 5px 15px
  background-color: #F3F3F3
  font-size: 14px
  font-weight: 500
  margin-bottom: 15px
</style>
<style lang="sass">
.product-short-characteristics
  .secondary-title
    font-size: 18px
.preorder-green-info
  padding: 10px 15px
  border: 1px solid #359D3F
  border-radius: 3px
  margin-bottom: 20px
  background-color: #EBF5EC
  +mmax($tablet)
    margin: 0 -15px 30px
    border-radius: 0
    border-left: none
    border-right: none
  &__title
    font-weight: 500
    font-size: 16px
    line-height: 24px
    color: #333
    margin-bottom: 5px
  &__text
    font-size: 14px
    line-height: 21px
    color: #333
    margin-bottom: 5px
  &__bottom-title
    font-size: 14px
    line-height: 17.5px
    font-weight: 500
    margin-bottom: 6px
</style>
